module.exports = __webpack_public_path__ + "static/img/samajuri (9).05acf32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (9).jpg
// module id = Its+
// module chunks = 0